import { ClientGetDiscovery, ClientGetDiscoveryResponse } from "../../proto/ClientGetDiscovery_pb";
import { ClientGetPoll, ClientGetPollResponse } from "../../proto/ClientGetPoll_pb";

export const ADD_DISCOVERY_PAGES = "ADD_DISCOVERY_PAGES";
export const ADD_MY_BILL_DISCOVERY = "ADD_MY_BILL_DISCOVERY";
export const RESET_MY_BILL_DISCOVERY = "RESET_MY_BILL_DISCOVERY";
export const DELETE_MY_BILL_DISCOVERY = "DELETE_MY_BILL_DISCOVERY";
export const ADD_VISITED_PAGE_DISCOVERY = "ADD_VISITED_PAGE_DISCOVERY";
export type DiscoveryPageType = {
  [pageId in ClientGetDiscovery.AsObject["pageId"]]: ClientGetDiscoveryResponse.AsObject;
};

export type DiscoveryPollPageType = {
  [pageId in ClientGetPoll.AsObject["pollId"]]: ClientGetPollResponse.AsObject;
};
export type DiscoveryVisitedPageType = Array<string>;

export type DiscoveryStateType = {
  // pages: DiscoveryPageType | DiscoveryPollPageType;
    pages:any
  myBills: Array<DiscoveryMyBillType>;
  visitedPages: DiscoveryVisitedPageType;
};

export type DiscoveryMyBillType = {
  id: string;
  title: string | null;
  type: string | null;
  billId: string | null;
  paymentCode: string | null;
  price: string | null;
  deadLine: string | null;
  tel: string | null;
  lastTermAmount: string | null;
  midTermAmount: string | null;
  subCode: string;
};

// export type DiscoveryPageStateType = {
//   pages: DiscoveryPageType | DiscoveryPollPageType;
// };

export type AddDiscoveryPagesActionType = {
  type: typeof ADD_DISCOVERY_PAGES;
  payload: DiscoveryPageType | DiscoveryPollPageType;
};
export type deleteDiscoveryMyBillActionType = {
  type: typeof DELETE_MY_BILL_DISCOVERY;
  payload: DiscoveryMyBillType["id"];
};
export type AddDiscoveryMyBillActionType = {
  type: typeof ADD_MY_BILL_DISCOVERY;
  payload: DiscoveryMyBillType;
};
export type resetDiscoveryMyBillActionType = {
  type: typeof RESET_MY_BILL_DISCOVERY;
  payload: [];
};
export type addDiscoveryVisitedPageType = {
  type: typeof ADD_VISITED_PAGE_DISCOVERY;
  payload: string | Array<string>;
};

export type DiscoveryActionTypes = AddDiscoveryPagesActionType | AddDiscoveryMyBillActionType | resetDiscoveryMyBillActionType | deleteDiscoveryMyBillActionType | addDiscoveryVisitedPageType;
